module.exports = __webpack_public_path__ + "static/media/member-img-3.1afa16fd.png";